import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {MiniCartComponent, MiniCartComponentService} from '@spartacus/cart/base/components/mini-cart';

@Component({
    selector: 'app-uig-mini-cart',
    templateUrl: './uig-mini-cart.component.html',
    styleUrls: ['./uig-mini-cart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigMiniCartComponent extends MiniCartComponent implements OnInit {

  constructor(protected miniCartComponentService: MiniCartComponentService) {
    super(miniCartComponentService);
  }

  ngOnInit(): void {
  }

}
